import { Link } from "react-router-dom";
// lucide 1.x ships no brand marks by design; a generic code glyph plus the
// visible "Source" label avoids misrepresenting anyone's logo.
import { ArrowUpRight, BookOpen, FileText, GitBranch } from "lucide-react";

function Footer() {
  return (
    <footer className="footer">
      <div className="shell shell--wide">
        <div className="footer__grid">
          <div>
            <img src="/logo.png" alt="DocCompare" style={{ height: 20, marginBottom: "var(--space-4)" }} />
            <p className="meta" style={{ maxWidth: "36ch" }}>
              Finds text hidden inside a PDF, and scores document similarity on what is
              actually printed on the page.
            </p>
          </div>

          <div>
            <h2 className="footer__col-title">Tools</h2>
            <ul className="stack" style={{ padding: 0, listStyle: "none", margin: 0 }}>
              <li>
                <Link className="footer__link" to="/compare">
                  Compare documents
                </Link>
              </li>
              <li>
                <Link className="footer__link" to="/injection">
                  Detect injection
                </Link>
              </li>
              <li>
                <Link className="footer__link" to="/">
                  How it works
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="footer__col-title">Project</h2>
            <ul className="stack" style={{ padding: 0, listStyle: "none", margin: 0 }}>
              <li>
                <a
                  className="footer__link"
                  href="https://doccompare-docs.netlify.app/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <BookOpen size={14} aria-hidden="true" />
                  Documentation
                  <ArrowUpRight size={12} aria-hidden="true" />
                  <span className="sr-only">(opens in a new tab)</span>
                </a>
              </li>
              <li>
                <a
                  className="footer__link"
                  href="https://doi.org/10.3390/math10224256"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <FileText size={14} aria-hidden="true" />
                  The paper
                  <ArrowUpRight size={12} aria-hidden="true" />
                  <span className="sr-only">(opens in a new tab)</span>
                </a>
              </li>
              <li>
                <a
                  className="footer__link"
                  href="https://github.com/SVijayB/DocCompare"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <GitBranch size={14} aria-hidden="true" />
                  Source
                  <ArrowUpRight size={12} aria-hidden="true" />
                  <span className="sr-only">(opens in a new tab)</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bar">
          <span>DocCompare · v1.0.0-alpha</span>
          <span className="mono">HPH · VPH · winnowing · k = 5 · t = 8</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
